function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_122",
  "data-name": "Grupo 122",
  transform: "translate(-6.588)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_zocial-www",
  "data-name": "Icon zocial-www",
  transform: "translate(6.588 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_116",
  "data-name": "Grupo 116",
  transform: "translate(0.273)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_48",
  "data-name": "Caminho 48",
  d: "M63.307,38.9l7.131-22.5",
  transform: "translate(-62.068 -16.4)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_49",
  "data-name": "Caminho 49",
  d: "M127.489,38.9,142.96,16.4",
  transform: "translate(-124.613 -16.4)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_50",
  "data-name": "Caminho 50",
  d: "M151.753,38.957l7.128-22.485",
  transform: "translate(-139.916 -16.459)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_51",
  "data-name": "Caminho 51",
  d: "M218.509,38.9l7.131-22.5",
  transform: "translate(-204.971 -16.4)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_52",
  "data-name": "Caminho 52",
  d: "M31.2,39,46.724,16.4",
  transform: "translate(-28.384 -16.4)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_53",
  "data-name": "Caminho 53",
  d: "M14.782,39l7.184-22.6",
  transform: "translate(-14.782 -16.4)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_54",
  "data-name": "Caminho 54",
  d: "M18.864,53.094H38.689",
  transform: "translate(-18.163 -42.72)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_55",
  "data-name": "Caminho 55",
  d: "M18.864,27.257H38.689",
  transform: "translate(-18.163 -25.394)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_56",
  "data-name": "Caminho 56",
  d: "M18.864,84.718H38.689",
  transform: "translate(-18.163 -64.113)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_57",
  "data-name": "Caminho 57",
  d: "M18.864,58.877H38.689",
  transform: "translate(-18.163 -46.868)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_58",
  "data-name": "Caminho 58",
  d: "M84.007,38.9,80.758,16.4",
  transform: "translate(-75.68 -16.4)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_59",
  "data-name": "Caminho 59",
  d: "M136.165,39.307l-3.228-22.412",
  transform: "translate(-123.837 -16.81)",
  fill: "#ee9032"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_60",
  "data-name": "Caminho 60",
  d: "M196.529,38.9,193.28,16.4",
  transform: "translate(-179.543 -16.4)",
  fill: "#ee9032"
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_95",
  "data-name": "Caminho 95",
  d: "M78.54,111.689A11.05,11.05,0,0,0,68,119.4h1.562a9.274,9.274,0,0,1,.581-1.275h3.006a13.126,13.126,0,0,0-.328,1.275h1.523a12.166,12.166,0,0,1,.384-1.275h2.9V119.4H79.1v-1.275h3.134a11.343,11.343,0,0,1,.43,1.275h1.523a12.733,12.733,0,0,0-.368-1.275h3.121a9.274,9.274,0,0,1,.581,1.275h1.559A11.046,11.046,0,0,0,78.54,111.689Zm2.219,1.764a9.548,9.548,0,0,1,5.156,3.173H83.188A10.494,10.494,0,0,0,80.759,113.453Zm-4.867.11a9.955,9.955,0,0,0-2.166,3.063h-2.56A9.546,9.546,0,0,1,75.892,113.563Zm3.207.482a8.577,8.577,0,0,1,2.373,2.581H79.1Zm-1.47.01v2.571H75.413A7.893,7.893,0,0,1,77.628,114.055Zm-9.19,6.8a.619.619,0,0,0-.368.1.309.309,0,0,0-.148.258,1.007,1.007,0,0,0,.069.315l.781,2.29c.024.068.051.146.082.228a.787.787,0,0,0,.125.218.514.514,0,0,0,.207.147.855.855,0,0,0,.328.054.739.739,0,0,0,.391-.09.54.54,0,0,0,.207-.2,3.633,3.633,0,0,0,.144-.338l.7-2.008.7,2.019c.058.15.1.26.141.331a.525.525,0,0,0,.2.2.759.759,0,0,0,.394.087.748.748,0,0,0,.4-.09.535.535,0,0,0,.2-.208,3.357,3.357,0,0,0,.135-.348l.781-2.29a1.119,1.119,0,0,0,.072-.315.307.307,0,0,0-.151-.258.623.623,0,0,0-.364-.1.569.569,0,0,0-.331.08.456.456,0,0,0-.158.177,1.9,1.9,0,0,0-.089.251l-.551,1.948-.617-1.824a3.446,3.446,0,0,0-.141-.335.569.569,0,0,0-.207-.2.773.773,0,0,0-.417-.094.814.814,0,0,0-.417.09.575.575,0,0,0-.22.211,2.455,2.455,0,0,0-.141.331l-.614,1.824-.555-1.962a1.123,1.123,0,0,0-.167-.358A.48.48,0,0,0,68.438,120.851Zm7.559,0a.619.619,0,0,0-.368.1.309.309,0,0,0-.148.258,1.032,1.032,0,0,0,.072.315l.781,2.29c.024.068.051.146.082.228a.779.779,0,0,0,.121.218.514.514,0,0,0,.207.147.855.855,0,0,0,.328.054.752.752,0,0,0,.394-.09.529.529,0,0,0,.2-.2,3.637,3.637,0,0,0,.144-.338l.7-2.008.7,2.019c.058.15.1.26.141.331a.525.525,0,0,0,.2.2.759.759,0,0,0,.394.087.748.748,0,0,0,.4-.09.535.535,0,0,0,.2-.208,3.356,3.356,0,0,0,.135-.348l.781-2.29a1.12,1.12,0,0,0,.072-.315.307.307,0,0,0-.151-.258.623.623,0,0,0-.364-.1.569.569,0,0,0-.331.08.456.456,0,0,0-.158.177,1.9,1.9,0,0,0-.089.251l-.551,1.948-.617-1.824a3.451,3.451,0,0,0-.141-.335.557.557,0,0,0-.2-.2.773.773,0,0,0-.417-.094.827.827,0,0,0-.42.09.575.575,0,0,0-.22.211,2.455,2.455,0,0,0-.141.331l-.614,1.824-.555-1.962a1.123,1.123,0,0,0-.164-.358A.487.487,0,0,0,76,120.851Zm7.559,0a.619.619,0,0,0-.368.1.309.309,0,0,0-.148.258,1.032,1.032,0,0,0,.072.315l.781,2.29c.024.068.051.146.082.228a.779.779,0,0,0,.121.218.514.514,0,0,0,.207.147.855.855,0,0,0,.328.054.751.751,0,0,0,.394-.09.529.529,0,0,0,.2-.2,3.461,3.461,0,0,0,.148-.338l.7-2.008.7,2.019c.058.15.1.26.141.331a.525.525,0,0,0,.2.2.759.759,0,0,0,.394.087.748.748,0,0,0,.4-.09.535.535,0,0,0,.2-.208,3.348,3.348,0,0,0,.135-.348l.781-2.29a1.118,1.118,0,0,0,.072-.315.3.3,0,0,0-.148-.258.634.634,0,0,0-.368-.1.569.569,0,0,0-.332.08.456.456,0,0,0-.158.177,1.9,1.9,0,0,0-.089.251l-.548,1.948-.62-1.824a3.444,3.444,0,0,0-.141-.335.557.557,0,0,0-.2-.2.773.773,0,0,0-.417-.094.827.827,0,0,0-.42.09.575.575,0,0,0-.22.211,2.453,2.453,0,0,0-.141.331l-.614,1.824-.551-1.962a1.123,1.123,0,0,0-.167-.358A.487.487,0,0,0,83.555,120.851Zm-15.613,4.864a11.054,11.054,0,0,0,21.2,0H87.586a9.336,9.336,0,0,1-.532,1.249H83.9c.134-.409.245-.826.338-1.249h-1.5a10.637,10.637,0,0,1-.384,1.249H79.1v-1.249h-1.47v1.249H74.651a12.879,12.879,0,0,1-.348-1.249h-1.51c.085.423.188.84.305,1.249H70.027a9.35,9.35,0,0,1-.535-1.249Zm3.049,2.748h2.635a9.533,9.533,0,0,0,2.169,3.264A9.536,9.536,0,0,1,70.992,128.463Zm4.273,0h2.363v2.8A7.105,7.105,0,0,1,75.265,128.463Zm3.833,0h2.527a8.148,8.148,0,0,1-2.527,2.732Zm4.217,0h2.773a9.539,9.539,0,0,1-5.4,3.418A10.069,10.069,0,0,0,83.316,128.463Z",
  transform: "translate(-67.923 -111.358)",
  fill: "#ee9032"
})));

var SvgNetIcon = function SvgNetIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.215,
    height: 22.598,
    viewBox: "0 0 21.215 22.598",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNetIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/net_icon.ddf6cad2.svg";
export { ForwardRef as ReactComponent };